
import React, { useState , useContext } from "react";
import { Link, NavLink } from "react-router-dom";
import  { currencySymbol }  from "../../functions/Function";
import { HomeContext } from "../Home";

const FavoriteItem = (props) => {
    const HomeContextData = useContext(HomeContext);
    return (
        <>
            <li className={`ivo-left-index-li ivo-ovrflow-hidden ${HomeContextData.getActiveProdcutID() == props.product.product_id ? 'active' : ''} `} onClick={()=>props
            .handleClickActiveProduct(props.product.product_id)}>
                <Link>
                    <div className="ivo-left-ul-inner-conent">
                        {props.product.product_name}
                    </div>
                    <div className="ivo-left-ul-inner-conent-v-2 hover-price-list">
                        
                        {props.product.price}
                    </div>
                    <span className="delete-list-item" onClick={()=> props.HandleDeleteFavItem(props.product.favorite_id , props.arr)} >
                       
                        <i className="fa-regular fa-trash-can"></i>
                    </span>
                </Link>
            </li>
        </>

    );
}

export default FavoriteItem;
